// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2nuAc","content":"GlobalSearch_content__2rwMs"};